<template>
  <v-hover>
    <v-list-item>
      <v-list-item-avatar>
        <v-hover>
          <v-btn
            slot-scope="{ hover: actionHover }"
            icon
            fab
            small
            outlined
            :color="iconColor(actionHover)"
            @click="taskAction"
          >
            <v-icon>{{ taskIcon() }}</v-icon>
          </v-btn>
        </v-hover>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title>{{ taskLabel }}</v-list-item-title>
        <v-list-item-subtitle>{{ taskDescription }}</v-list-item-subtitle>
      </v-list-item-content>


      <v-list-item-action>
        <v-list-item-action-text>{{ createdAgo }}</v-list-item-action-text>
      </v-list-item-action>
    </v-list-item>
  </v-hover>
</template>
<script>
  import moment from 'moment'
  import { isEmpty } from 'lodash'

  export default {
    props:{
      task: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        model: { ...this.task }
      }
    },
    computed: {
      taskLabel() {
        return this.model.label
      },
      taskDescription() {
        return this.model.description
      },
      createdAgo() {
        return this.task && this.task.createdAt
          ? moment(this.task.createdAt.toDate()).fromNow(/* true */)
          : ''
      },
      isComplete() {
        return this.task.isComplete
      }
    },
    watch: {
      task() {
        this.model = { ...this.task }
      }
    },
    methods: {
      completeTask(){
        this.$store.dispatch('completeTask', this.model.id)
      },
      claimTask(){
        this.$store.dispatch('claimTask', this.model.id)
      },
      taskIcon() {
        return isEmpty(this.model.claimedBy)
          ? 'outlined_flag'
          : 'check'
      },
      taskAction() {
        const isClaimed = !isEmpty(this.model.claimedBy)

        if(isClaimed){
          this.completeTask()
        }else {
          this.claimTask()
        }
      },
      iconColor() {
        return isEmpty(this.model.claimedBy)
          ? 'primary'
          : 'primary'
      }
    }
  }
</script>
